import type { CardTypeDto } from "src/app/features/CardType/types/CardTypeDto";
import type { CardTypeEntity } from "src/app/features/CardType/types/CardTypeEntity";

export const cardTypeEntityToDto = ({ dynamicProperties, ...rest }: Readonly<CardTypeEntity>): CardTypeDto => {
    const propValues = dynamicProperties?.dynamicPropertyValues?.map((propValue) => {
        const value = propValue.type === "TEXT" ? propValue.value || "" : propValue.value;

        return {
            id: propValue.id,
            key: propValue.key,
            type: propValue.type,
            label: propValue.label,
            pattern: propValue.pattern ?? "",
            readOnly: propValue.readOnly || false,
            value,
        };
    });

    return {
        ...rest,
        dynamicProperties: {
            ...dynamicProperties,
            dynamicPropertyValues: propValues,
        },
    };
};
